import axios from 'axios'

// Get all show dates from business
const getAll = async (iniDate = null, endDate = null) => {
  let now = null
  if (!iniDate && !endDate) {
    now = new Date()
    iniDate = now.toISOString().split('T')[0]
    now.setFullYear(now.getFullYear() + 1)
    endDate = now.toISOString().split('T')[0]
  } else {
    now = new Date(iniDate)
    iniDate = now.toISOString().split('T')[0]
    now = new Date(endDate)
    endDate = now.toISOString().split('T')[0]
  }
  const { data } = await axios.get(`${process.env.VUE_APP_API}/show-date/for-register-ticket/${iniDate}/${endDate}`)
  return data
}

// Get all show dates from business
const getForTickets = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/show-date/for-register-ticket`)
  return data
}

// Get all show dates from business
const getForValidator = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/show-date/for-validator`)
  return data
}

// Get show date from id
const get = async (id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/show-date/${id}/business_event`)
  return data
}

// Create show date
const create = async (
  show,
  dates,
  dateSale,
  localSale,
  hourCloseSale = 0,
  maxTicketUser,
  prices,
  booking = false,
  withoutStage = false,
  clientInterest,
  installments,
  distanceRule,
  withSection
) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/show-date`, {
    show,
    dates,
    dateSale,
    localSale,
    hourCloseSale,
    maxTicketUser,
    prices,
    booking,
    withoutStage,
    clientInterest,
    installments,
    distanceRule,
    withSection
  })
  return data
}

// Update show date
const update = async (
  show,
  dates,
  dateSale,
  localSale,
  hourCloseSale,
  maxTicketUser,
  withoutStage = false,
  installments,
  withSection,
  distanceRule,
  booking,
  clientInterest,
  showDate

) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/show-date/${show}`, {
    dates,
    dateSale,
    localSale,
    hourCloseSale,
    maxTicketUser,
    withoutStage,
    installments,
    withSection,
    distanceRule,
    booking,
    clientInterest,
    showDate
  })
  return data
}

// Cancel show date
const cancel = async (id, reason) => {
  const { data } = await axios.delete(`${process.env.VUE_APP_API}/show-date/${id}`, { data: { reason } })
  return data
}

// Create show price
const createPrice = async (
  showDate,
  section,
  ticketType,
  price,
  sell,
  special = false,
  ticketDesc
) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/show-date/${showDate}/price`, {
    section,
    ticketType,
    price,
    sell,
    special,
    ticketDesc
  })
  return data
}

// Update show price
const updatePrice = async (
  id,
  showDate,
  ticketType,
  price,
  sell,
  active,
  ticketDesc
) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/show-date/${showDate}/price/${id}`, {
    ticketType,
    price,
    sell,
    active,
    ticketDesc
  })
  return data
}

// Remove show price
const removePrice = async (id, showDate) => {
  const { data } = await axios.delete(`${process.env.VUE_APP_API}/show-date/${showDate}/price/${id}`)
  return data
}

// Update show price order
const updatePriceOrder = async (showDate, prices) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/show-date/${showDate}/price/order`, prices)
  return data
}

// Update show price amount
const updatePriceAmount = async (showDate, prices) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/show-date/${showDate}/price/amount`, prices)
  return data
}

// Get all show dates canceled
const getCanceled = async (iniDate, endDate) => {
  iniDate = (new Date(iniDate)).toISOString().split('T')[0]
  endDate = (new Date(endDate)).toISOString().split('T')[0]
  const { data } = await axios.get(`${process.env.VUE_APP_API}/show-date/for-register-ticket/canceled/${iniDate}/${endDate}`)
  return data
}

const undoCancel = async (id) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/show-date/cancel/undo/${id}`)
  return data
}

export {
  getAll,
  getForTickets,
  get,
  create,
  update,
  cancel,
  getForValidator,
  createPrice,
  updatePrice,
  removePrice,
  updatePriceOrder,
  updatePriceAmount,
  getCanceled,
  undoCancel
}
